import EntitySearchInput from 'components/form/EntitySearch/EntitySearchInput'
import React from 'react'
import { usePerfil } from 'useAuth';
import Fazenda from 'entity/Fazenda';
export default function SeletorFazendas({ name, label, ...otherProps }) {
    const perfil = usePerfil();
    function queryExtra(query) {
        if (perfil) {
            if (perfil.tipoPerfil === "admin") {

            } else {
                query = query.where("perfisAutorizados", "array-contains", perfil.uid);
            }
        } else {
            query = query.where("uid", "==", "")
        }
        return query;
    }
    return (

        <EntitySearchInput
            name={name}
            label={label}
            EntityClass={Fazenda}
            extraQuery={queryExtra}
            {...otherProps}
        />

    )
}
